import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { StripeIntent } from '../../models/stripe/stripe-intent';
import { FormGroup, Validators, FormControl } from '../../../../node_modules/@angular/forms';
import { StripeService } from '../../services/stripe.service';
declare var Stripe;
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { PracticeService } from 'src/app/services/practice.service';
import * as moment from 'moment';

@Component({
  selector: 'app-seatscription',
  templateUrl: './seatscription.component.html',
  styleUrls: ['./seatscription.component.scss']
})
export class SeatscriptionComponent implements OnInit {
  public subs;
  public seats;
  public cancelledActiveSeats;
  public loading:boolean=true;
  private publishableKey:string;
  private intent: StripeIntent;
  private stripe;
  private cardElement: any;
  public errorMessage=null;
  public stripeForm:FormGroup;
  public processingPayment:boolean = false;
  public processingCancel:boolean=false;
  public planId:string;
  public billingCycleAnchor;
  public quantity:number;
  public cancelledActiveQuantity:number=0;
  private customer;
  public practice;
  public practiceLoading:boolean=true;
  public takenSeats:number=0;
  public bacsSeats:number=0;

  constructor(
    private _stripe: StripeService,
    private _auth: AuthenticationService,
    private _sub: SubscriptionService,
    private _router: Router,
    private _practice: PracticeService
  ) {
    if(!this._auth.loggedIn.value){
      this._router.navigate(['/login']);
    }
    this.publishableKey=environment.stripePublishableKey;
    this.stripe=Stripe(this.publishableKey);
  }

  public getSub(){
    this._sub.getSubDetail(this.seats.subscription_id).subscribe(
      res=>{
        console.log(res);
      }
    );
  }

  private getSubs(){
    this._sub.getUserSubscriptions().subscribe(
      res=> {
        if(res){
          res.forEach(sub=>{
            let then=moment(sub.sub_until);
            let now=moment(new Date());
            let compare=false;
              if (then > now) {
                compare=true;
              }
            if(
              compare
              && (
                sub.plan.stripe_reference == 'annual_practice'
                || sub.plan.stripe_reference == 'monthly_practice')
            ) {
              this.subs=sub;
            }
            if(
              compare
              && (
                sub.plan.stripe_reference == 'annual_seats'
                || sub.plan.stripe_reference == 'monthly_seats')
              && sub.status=='active'
            ) {
              this.seats=sub;
              this.quantity=sub.quantity;
            }
            if(
              compare
              && (
                sub.plan.stripe_reference == 'annual_seats'
                || sub.plan.stripe_reference == 'monthly_seats')
              && sub.status!='active'
              && sub.status!='incomplete'
            ) {
              this.cancelledActiveSeats=sub;
              this.cancelledActiveQuantity+=sub.quantity;
            }
            this.loading=false;
          });
          this.setFormPlanId();
        }
      }
    );
  }

  getMyPractice(){
    this._practice.getMyPractice().subscribe(practice=>{
      this.practice = practice;
      this.countUpSeats();
      this.practiceLoading=false;
    })
  }

  public countUpSeats(){
    this.practice.members.forEach(member=>{
      if(member.practice_status==1) this.takenSeats++;
    });
    this.bacsSeats=this.practice.bacsSeats;
    if(this.practice.is_bacs_enabled) this.quantity=this.practice.bacsSeats;
  }

  private setFormPlanId(){
    if(this.subs &&  this.subs.plan.stripe_reference=='annual_practice') this.planId='annual_seats';
    if(this.subs &&  this.subs.plan.stripe_reference=='monthly_practice') this.planId='monthly_seats';
    if(this.subs && this.subs.sub_until) this.billingCycleAnchor=(Math.floor((new Date(this.subs.sub_until).getTime()+1)/1000));
  }

  public cancelSeats(){
    if(!confirm('Confirm seat subscription cancellation')) return false;
    this.processingCancel=true;
    this._sub.cancelSubscription(this.seats.subscription_id).subscribe(
      res=>{
        this._router.navigate(['/practice']);
      }
    );
  }

  public updateBacsSeats(){
    this.processingPayment=true;
    if(!confirm('Confirm seat number update')) return false;
    this._practice.updatePracticeBacsSeats(this.practice.id, this.quantity).subscribe(
      res=>{
        if(res.message) {
          this.errorMessage=res.message;
          this.processingPayment=false;
        } else {
          this._router.navigate(['/practice']);
        }
      }
    );
  }

  public updateSeats(){
    if(!confirm('Confirm seat number change')) return false;
    this.processingPayment=true;
    this._stripe.updateSubscription(this.seats.subscription_id, this.quantity).subscribe(
      res=>{
        if(res.status=='incomplete'){
          this.errorMessage=res.message;
          this.processingPayment=false;
        }else if(res.status=='active'){
          this._router.navigate(['/practice']);
        }
      },err=>{
        this.processingPayment = false;
        this.errorMessage = err.error.message;
      }
    );
  }

  public createSeats(){
    if(!confirm('Confirm seat subscription creation')) return false;
    this.processingPayment=true;
    this._stripe.createSubscription(this.planId, this.quantity, this.billingCycleAnchor).subscribe(res=>{
      if(res.status=='incomplete'){
        this.errorMessage=res.message;
        this.processingPayment=false;
      }else if(res.status=='active'){
        this._router.navigate(['/practice']);
      }
    },err=>{
      this.processingPayment = false;
      this.errorMessage = err.error.message;
    });
  }

  ngOnInit() {
    this.getSubs();
    this.getMyPractice();
  }

}
